module.exports = __webpack_public_path__ + "static/media/dispatch_systemmoduleC-icon5.90290754.png";